module.exports = {
  'productive-standard': 'cubic-bezier(0.2, 0, 0.38, 0.9)',
  'expressive-standard': 'cubic-bezier(0.4, 0.14, 0.3, 1)',
  'productive-enter': 'cubic-bezier(0, 0, 0.38, 0.9)',
  'expressive-enter': 'cubic-bezier(0, 0, 0.3, 1)',
  'productive-exit': 'cubic-bezier(0.2, 0, 1, 0.9)',
  'expressive-exit': 'cubic-bezier(0.4, 0.14, 1, 1)'
}
